import React, {Fragment, PureComponent} from 'react';
import PropTypes, {arrayOf, shape} from 'prop-types';
import {connect} from 'react-redux';
import cx from 'classnames';

import FriendStatus from './friend-status/FriendStatus';
import {colors} from '../../constants';
import Avatar from '../avatar/Avatar';
import {getMessage, mapMessageStateToProps} from '../message/Message';

import styles from './FriendStatusList.pcss';
import SmallSocialCard from '../small-social-card/SmallSocialCard';

class FriendStatusList extends PureComponent {
    static propTypes = {
        friends: arrayOf(
            shape({
                id: PropTypes.string,
                avatar: PropTypes.string,
                name: PropTypes.string,
                presence: PropTypes.string,
                icon: PropTypes.string
            })
        ),
        isLoading: PropTypes.bool,
        messages: PropTypes.object.isRequired,
        onClick: PropTypes.func
    };

    static defaultProps = {
        isLoading: false,
        friends: []
    };

    renderAvatar = ({avatar, name, id, presence}) => {
        return (
            <Avatar
                key={id}
                avatar={avatar}
                displayName={name}
                backgroundColor={colors.BLUE}
                presence={presence}
            />
        );
    };

    renderFriends = friendList => {
        const {onClick} = this.props;

        return friendList.map(friend => (
            <li key={friend.id}>
                <FriendStatus onClick={onClick} {...friend} />
            </li>
        ));
    };

    render() {
        const {friends, isLoading, messages, onClick} = this.props;

        const numFriends = friends && friends.length;
        const hasMultipleFriendsOnline = numFriends > 1;
        const hasOneFriendOnline = numFriends === 1;

        const slicedFriends = friends.slice(0, 3);
        const slicedFriendsAvatars = numFriends < 3 ? friends.slice(0, numFriends) : slicedFriends;

        if (isLoading) {
            return (
                <ul className={styles.wrapper}>
                    <li>
                        <FriendStatus placeholder />
                    </li>
                    <li className={styles.showLarge}>
                        <FriendStatus placeholder />
                    </li>
                </ul>
            );
        }

        return (
            <Fragment>
                <ul className={cx(styles.wrapper, styles.showLarge)}>
                    {this.renderFriends(slicedFriends)}
                </ul>

                {hasMultipleFriendsOnline && (
                    <SmallSocialCard
                        primaryText="diesel.common.friend_status_list.friends_online"
                        secondaryText={friends.length}
                        onClick={onClick}
                        isFriends>
                        {slicedFriendsAvatars.map(this.renderAvatar)}
                    </SmallSocialCard>
                )}

                {hasOneFriendOnline && (
                    <SmallSocialCard
                        primaryText={getMessage(
                            messages,
                            'diesel.common.friend_status_list.friend_is_online',
                            [friends[0].name]
                        )}
                        onClick={onClick}
                        isFriends>
                        {this.renderAvatar(friends[0])}
                    </SmallSocialCard>
                )}
            </Fragment>
        );
    }
}

export default connect(mapMessageStateToProps)(FriendStatusList);
